import { IUserEx, SimpleUser } from "@vierkant-software/types__api";
import { AutoSyncServiceBase, SyncLoadedData } from "./sync.service";
import { DateTime } from "luxon";
import { Injectable } from "@angular/core";

export enum UserDetailLevel {
    simple = 0,
    simpleWithBirthday = 1,
    full = 127,
}

type UserDetailType = {
    [UserDetailLevel.simple]: SimpleUser & { image_ID: string };
    [UserDetailLevel.simpleWithBirthday]: SimpleUser & { image_ID: string };
    [UserDetailLevel.full]: IUserEx;
};

@Injectable({ providedIn: "root" })
export class UserSyncService extends AutoSyncServiceBase<UserDetailType, UserDetailLevel> {
    override getDefaultValue(ID: string, detail?: UserDetailLevel): UserDetailType[UserDetailLevel] {
        return {
            ID,
            firstname:    "???",
            lastname:     "?????",
            birthday:     DateTime.fromMillis(0),
            defaultColor: [0,0],
            userColor:    [0,0]
        };
    }
    protected readonly syncName = "userSync";

    protected mapFiles(data: SyncLoadedData<UserDetailType, UserDetailLevel>[], files: string[]): SyncLoadedData<UserDetailType, UserDetailLevel>[] {
        return data.map((entry, i) => {
            return {
                ...entry,
                data: {
                    ...entry.data,
                    image_ID: files[i]
                }
            };
        });
    }
}
